import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, map, switchMap } from 'rxjs';
import { ChopAlterskategorie, ChopKatalog, ChopLeistungsgruppe, ChopPunktekategorie } from '@entity/chop';
import { ChopService } from '@service/chop.service';

export interface ChopAlterskategorieDetailData {
  alterskategorie: ChopAlterskategorie;
  katalog: ChopKatalog;
  leistungsgruppen: ChopLeistungsgruppe[];
  punktekategorien: ChopPunktekategorie[];
}

export const ChopAlterskategorieDetailResolve: ResolveFn<ChopAlterskategorieDetailData> = (route) => {
  const chopService = inject(ChopService);
  return chopService.getAlterskategorie(+route.params.alterskategorieId).pipe(
    switchMap((alterskategorie) =>
      forkJoin({
        katalog: chopService.getKatalog(alterskategorie.chopKatalogId),
        leistungsgruppen: chopService.getLeistungsgruppen(alterskategorie.id),
        punktekategorien: chopService.getPunktekategorien(alterskategorie.id),
      }).pipe(map((rest) => ({ alterskategorie, ...rest })))
    )
  );
};
